import moment from "moment";

export const RELEASE_QUERY_KEY = "appReleases";
export const REFRESH_INTERVAL_MS = 60000;

export const STATUS_DISPLAY = {
  draft: { label: "Draft", color: "default" },
  rolling: { label: "Rolling out", color: "primary" },
  paused: { label: "Paused", color: "warning" },
  approval: { label: "Waiting for approval", color: "warning" },
  publish: { label: "Ready to publish", color: "accent" },
  stable: { label: "Stable", color: "success" },
  blocked: { label: "Blocked", color: "danger" },
  rolled_back: { label: "Rolled back", color: "danger" },
};

// Manual is the hand-picked flow; direct is a bridge upload sent to every outlet at once.
export const isManualMode = (mode) => mode === "manual";

export const getStatusDisplay = (status) =>
  STATUS_DISPLAY[status] || { label: status, color: "default" };

// API.js rejects with the response body, or a TypeError when no response came back.
export const getErrorMessage = (error) => {
  if (!error || error instanceof TypeError) {
    return "Could not reach the server. Check your connection and try again.";
  }
  if (error.errors) {
    const [first] = Object.values(error.errors);
    if (first) return Array.isArray(first) ? first[0] : first;
  }
  return error.message || "Something went wrong. Please try again.";
};

export const formatDateTime = (value) =>
  value ? moment(value).format("D MMM YYYY, h:mm A") : "-";

export const getOutletId = (outlet) =>
  outlet.outlet_id !== undefined ? outlet.outlet_id : outlet.id;

export const isOutletPicked = (outlet) =>
  Boolean(outlet.picked_by) && !outlet.removed_at;

export const isOutletOnRelease = (outlet, release) =>
  outlet.app_version === release.version;

export const getOutletStatus = (outlet, release) => {
  if (outlet.removed_at) {
    return isOutletOnRelease(outlet, release)
      ? { label: "Going back", color: "danger" }
      : { label: "Removed", color: "default" };
  }
  if (outlet.hold) return { label: "On hold", color: "warning" };
  if (isOutletOnRelease(outlet, release)) {
    return { label: `On ${release.version}`, color: "success" };
  }
  if (isOutletPicked(outlet)) return { label: "Updating", color: "primary" };
  return { label: "Not picked", color: "default" };
};
